import cloneDeep from 'lodash/clone';

export const getGraph = (arr, rootNode) => {
  if (!arr.length) return [];
  const triggers = arr.map((t) => {
    return cloneDeep(t);
  });

  rootNode = rootNode || getRootNode(triggers);
  return rootNode ? [buildNodesGraph(rootNode, triggers)] : [];
};

const getRootNode = (triggers) => {
  const nodesWithoutParent = triggers.filter((i) => {
    return !i.wf_pid && !i.wf_detached;
  });

  nodesWithoutParent.sort((a, b) => {
    const aNestedCount = getNestedCount(a.id, triggers);
    const bNestedCount = getNestedCount(b.id, triggers);
    return aNestedCount > bNestedCount ? -1 : 1;
  });

  return nodesWithoutParent[0];
};

export const getNestedCount = (triggerId, triggers, visited = new Set()) => {
  // Cycle detected, skipping to prevent infinite recursion.
  if (visited.has(triggerId)) {
    return 0;
  }

  visited.add(triggerId);

  const childTriggers = triggers.filter(({ wf_pid }) => wf_pid === triggerId);
  let totalNested = childTriggers.length;

  for (const child of childTriggers) {
    totalNested += getNestedCount(child.id, triggers, visited);
  }

  visited.delete(triggerId); // clean up for other recursion paths

  return totalNested;
};

export const isTriggerInGraph = (trigger, arr) => {
  for (let i of arr) {
    if (i.id === trigger.id || isTriggerInGraph(trigger, i.nodes)) {
      return true;
    }
  }

  return false;
};

const isConditionTrigger = ({ type }) => {
  return type === 'conditional' || type === 'wait';
};

export const buildNodesGraph = (currentNode, allNodes) => {
  if (!currentNode?.id) return currentNode;

  let childNodes = allNodes.filter((node) => {
    return node.wf_pid === currentNode.id;
  });

  if (childNodes.length > 1 && !isConditionTrigger(currentNode)) {
    childNodes = childNodes.slice(0, 1);
  }

  if (isConditionTrigger) {
    childNodes = childNodes.filter((node, index) => {
      const nodeIndex = childNodes.findIndex((n) => {
        return n.wf_if === node.wf_if;
      });
      return index === nodeIndex;
    });
  }

  currentNode.nodes = childNodes.map((node) => {
    return buildNodesGraph(node, allNodes);
  });

  return currentNode;
};
